import { useRef, useState } from "react";

import { makePostApiCall } from "../../shared/makeApiCall";
import { useToast } from "../../contexts/ToastContext";

import DeleteConfirmationForm from "../../components/forms/DeleteConfirmationForm";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

export function CustomerGroupsViewModel(logout) {
  const { showSuccess } = useToast();
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [customerGroups, setCustomerGroups] = useState({
    data: [],
  });

  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const lastListFetchRef = useRef({ search: null, page: 1 });

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const getCustomerGroups = async function (search, page) {
    lastListFetchRef.current = { search, page };
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`customerGroups`, payload);
    setLoading(false);
    if (callResult.success) {
      setCustomerGroups(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch customer groups");
    }
  };

  const deleteCustomerGroup = async function (id) {
    let callResult = await makePostApiCall(`deleteCustomerGroup/${id}`);

    if (callResult.success) {
      setEmptyModelOpen({ open: false, childComponent: null });
      showSuccess(callResult.data?.message || "Customer group deleted");
      const { search, page } = lastListFetchRef.current;
      await getCustomerGroups(search, page);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      const msg =
        callResult.data?.message || "Could not delete customer group";
      showErrorModal("Could not delete customer group", msg);
    }
  };

  const openDeleteCustomerGroupModal = function (group) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteCustomerGroup(group.id)}
          message={`Delete customer group "${group.name}"? This cannot be undone.`}
          setOpen={setEmptyModelOpen}
          title="Delete customer group"
        />
      ),
      open: true,
    });
  };

  return {
    emptyModal,
    setEmptyModelOpen,
    getCustomerGroups,
    openDeleteCustomerGroupModal,
    loading,
    customerGroups,
    setSlideOver,
    slideOver,
  };
}
